// 体检预约
export default [
  /**
   * 选择医院
   */
  {
  path: '/medical/select-hos',
  component: () => import('Pages/medical/select-hos.vue')
},
  /**
   * 体检预约
   */
  {
  path: '/medical/institution-desc',
  component: () => import('Pages/medical/institution-desc.vue')
},
  /**
   * 体检套餐详情
   */
  {
  path: '/medical/institution-appointment',
  component: () => import('Pages/medical/medical-appointment.vue')
},
  /**
   * 确认体检订单
   */
  {
  path: '/medical/confirm-order',
  component: () => import('Pages/medical/confirm-order.vue')
},
  /**
   *我的体检订单列表
   */
  {
  path: '/medical/medical-order',
  component: () => import('Pages/medical/medical-order.vue')
},
  /**
   * 我的体检订单详情
   * query
   * **** id
   */
  {
    path: '/medical/medical-order/detail',
    component: () => import('Pages/medical/medical-order-detail.vue')
  },

  /**
   * 体检订单支付成功回调页
   */
  {
    path: '/medical-succeed',
    component: () => import('Pages/medical/medical-succeed.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/medical.js